import React from 'react';
import './MachineMiniCard.css';

/* 사출기 미니 카드(접힘) — 사출기 현황 · 공장별 사출 현황이 함께 쓴다 (PNG 시안의 같은 카드).
 * 큰 번호(설비명 끝 숫자), 상태 아이콘(가동 ▷ / 대기 ‖ / 정지 □), 알람 수 배지, 금형번호, 샷카운트,
 * CAV(캐비티 수)·C/T(사이클 타임, 초). CAV·C/T 는 현장에서 꼭 보는 값이라 카드 아래 줄에 항상 둔다(값이 없으면 —).
 * 알람이 있으면 빨간 테두리·번호. 스타일은 mmc- 접두어. */

const STATUS_ICON = { running: 'play_circle', idle: 'pause_circle', stopped: 'stop_circle' };

/* "사출기 #57" → 57. 숫자가 없으면 null */
export const machineNumber = (name) => {
  const m = String(name || '').match(/(\d+)\s*$/);
  return m ? Number(m[1]) : null;
};

/* 0 이하·숫자 아님은 미측정 → — */
const positive = (v) => v != null && v !== '' && Number.isFinite(Number(v)) && Number(v) > 0;

function MachineMiniCard({ name, fallbackNo, status, alarms, moldNo, shotCount, cavity, cycleTime, moldLabel, shotLabel, cavLabel = 'CAV', ctLabel = 'C/T', statusLabel, alarmTitle, title, onClick, onAlarmClick }) {
  const alarm = Number(alarms) > 0;
  const no = machineNumber(name) ?? fallbackNo;
  const fire = (e) => { e.stopPropagation(); if (onAlarmClick) onAlarmClick(); };
  return (
    <button type="button" className={`mmc-card ${alarm ? 'mmc-alarm' : ''} mmc-status-${status || 'unknown'}`} onClick={onClick} title={title}>
      <span className="mmc-no" aria-hidden="true">{no == null ? '' : String(no).padStart(2, '0')}</span>
      <span className="mmc-icons">
        {alarm && (
          <span role="button" tabIndex={0} className="mmc-badge" title={alarmTitle} onClick={fire} onKeyDown={(e) => { if (e.key === 'Enter') fire(e); }}>
            {alarms}
          </span>
        )}
        <span className="material-symbols-outlined mmc-status-icon" title={statusLabel}>{STATUS_ICON[status] || 'stop_circle'}</span>
      </span>
      <span className="mmc-row">
        <span className="mmc-label">{moldLabel}</span>
        <span className="mmc-value">{moldNo || '—'}</span>
      </span>
      <span className="mmc-row">
        <span className="mmc-label">{shotLabel}</span>
        <span className="mmc-value">{shotCount == null || shotCount === '' ? '—' : Number(shotCount).toLocaleString()}</span>
      </span>
      <span className="mmc-row mmc-spec">
        <span className="mmc-spec-item">
          <span className="mmc-spec-label">{cavLabel}</span>
          <span className="mmc-spec-value">{positive(cavity) ? Number(cavity) : '—'}</span>
        </span>
        <span className="mmc-spec-item">
          <span className="mmc-spec-label">{ctLabel}</span>
          <span className="mmc-spec-value">{positive(cycleTime) ? `${Number(cycleTime).toFixed(1)}s` : '—'}</span>
        </span>
      </span>
    </button>
  );
}

export default MachineMiniCard;
